import Cookies from 'js-cookie';
import { createContext, Dispatch, FC, useEffect, useState } from 'react';
import useMediaQuery from '~js/React/components/CustomHooks/useMediaQuery';
import { getSessionId } from '~js/React/helpers';
import { EstateDto } from '~js/React/services/generatedApi';

interface ObjectPageContextTypes {
  mediaView: boolean;
  setMediaView: Dispatch<React.SetStateAction<boolean>>;
  mediaOption: string;
  setMediaOption: Dispatch<React.SetStateAction<string>>;
  accordionOption: string;
  setAccordionOption: Dispatch<React.SetStateAction<string>>;
  objectId: string;
  intake: boolean;
  sessionId: string;
  estate: EstateDto;
  isLoading: boolean;
  isAuthorizedBroker: boolean;
  showErrorObjectPage?: boolean;
  setShowErrorObjectPage(val: boolean): void;
  setOneViewing(val: boolean): void;
  oneViewing?: boolean;
  isBigScreen: boolean;
  isMediumScreen: boolean;
  isSmallScreen: boolean;
}

type Props = {
  children: React.ReactNode;
  objectId?: string;
  intake?: boolean;
  estateItem: EstateDto;
  isLoading: boolean;
  isBigScreen: boolean;
};

export const ObjectPageContext = createContext<ObjectPageContextTypes>(
  {} as ObjectPageContextTypes
);

const ObjectPageContextProvider: FC<Props> = ({
  children,
  objectId,
  intake,
  estateItem,
  isLoading,
  isBigScreen,
}) => {
  const sessionId = getSessionId();
  const [mediaView, setMediaView] = useState<boolean>(null);
  const [oneViewing, setOneViewing] = useState<boolean>(false);
  const [mediaOption, setMediaOption] = useState<string>('imageView');
  const [accordionOption, setAccordionOption] = useState<string>('');
  const [isAuthorizedBroker, setIsAuthorizedBroker] = useState<boolean>(false);
  const isMediumScreen = useMediaQuery('(min-width: 46rem)');
  const isSmallScreen = useMediaQuery('(max-width: 32rem)');

  const [showErrorObjectPage, setShowErrorObjectPage] =
    useState<boolean>(false);
  useEffect(() => {
    if (estateItem === null && !isLoading) {
      window.location.replace('/objektet-ar-borttaget/');
    }
  }, [estateItem, isLoading]);
  function imageViewChoice() {
    var url = window.location.href;
    if (url.indexOf('imageView') > -1) {
      setMediaOption('imageView');
      setMediaView(true);
    } else if (url.indexOf('constructPlan') > -1) {
      setMediaOption('constructPlan');
      setMediaView(true);
    } else if (url.indexOf('movieView') > -1) {
      setMediaOption('movieView');
      setMediaView(true);
    } else if (url.indexOf('3DView') > -1) {
      setMediaOption('3DView');
      setMediaView(true);
    } else if (url.indexOf('heliView') > -1) {
      setMediaOption('heliView');
      setMediaView(true);
    } else {
      setMediaView(false);
      setMediaOption('imageView');
    }
  }
  useEffect(() => {
    imageViewChoice();
  }, [objectId, window.history]);

  useEffect(() => {
    window.onpopstate = (e) => {
      imageViewChoice();
    };
  });

  useEffect(() => {
    var loginType = Cookies.get('loginType');
    setIsAuthorizedBroker(loginType === '2');
  }, [isLoading]);

  const contextObject: ObjectPageContextTypes = {
    mediaView,
    setMediaView,
    mediaOption,
    setMediaOption,
    accordionOption,
    setAccordionOption,
    objectId,
    intake,
    sessionId: sessionId,
    estate: estateItem,
    isLoading: isLoading,
    isAuthorizedBroker,
    showErrorObjectPage,
    setShowErrorObjectPage,
    oneViewing,
    setOneViewing,
    isBigScreen,
    isMediumScreen,
    isSmallScreen,
  };
  return (
    <ObjectPageContext.Provider value={contextObject}>
      {children}
    </ObjectPageContext.Provider>
  );
};

export default ObjectPageContextProvider;
